import React, { useMemo } from 'react';
import clsx from 'clsx';
import { CarIcon } from '../../icons';

const OrderCarCard = ({
  className,
  cardRef,
  carData,
  selectedCar,
  isAssignedView = false,
  isDashbord = false,
  handleCardClick,
}) => {
  const { plateno, title, subTitle, info, step } = carData;
  const isSelected = useMemo(() => {
    return plateno && selectedCar?.plateno === plateno;
  }, [selectedCar?.plateno, plateno]);

  return (
    <li
      ref={cardRef}
      className={clsx(
        `p-3 flex w-full items-center justify-between rounded-lg h-full ${
          isSelected ? 'bg-[#282828] text-white' : 'bg-white'
        }`,
        className
      )}
      onClick={handleCardClick && handleCardClick}
      key={plateno}
    >
      <div className="flex items-center justify-center gap-2 ">
        {isAssignedView ? (
          <div className="rounded-full bg-powdergrey p-3">
            <CarIcon className={'min-w-[20px]'} color={isSelected ? 'white' : 'black'} />
          </div>
        ) : (
          <CarIcon className={'min-w-[20px]'} color={isSelected ? 'white' : 'black'} />
        )}
        <div className="flex flex-col gap-1">
          <div className={clsx("text-body ", !isDashbord && 'w-[140px] truncate')} title={title}>
            {title}
          </div>
          <p
            className={`text-disclaimer font-[700] ${
              isDashbord ? [7, 8, 9].includes(step) ? 'text-primary':'text-fadedgrey' : 'w-[100px] truncate '
            }`}
            title={subTitle}
          >
            {subTitle}
          </p>
        </div>
      </div>
      <p
        className={`font-[700] text-[12px] ${
          [7, 8, 9].includes(step)
            ? 'text-primary'
            : isSelected
            ? 'white'
            : 'text-fadedgrey'
        }`}
        title={info}
      >
        {info}
      </p>
    </li>
  );
};

export default OrderCarCard;
